module.exports = __webpack_public_path__ + "img/eco_worthy_100Ah.6fdf6a64.png";